import * as Headless from '@headlessui/react'
import { InertiaLinkProps, Link as InertiaLink } from '@inertiajs/react'
import React, { forwardRef } from 'react'
import { classNames } from '@/Utils/Utils'

export const Link = forwardRef(function Link(
    props: InertiaLinkProps & React.ComponentPropsWithoutRef<'a'> & { underlined?: boolean },
    ref: React.ForwardedRef<HTMLAnchorElement>
) {
    const { className, underlined, ...rest } = props

    return (
        <Headless.DataInteractive>
            <InertiaLink className={classNames(underlined ? 'underline hover:text-sky-800' : '', props.className)} {...rest} ref={ref} />
        </Headless.DataInteractive>
    )
})

export function ExternalLink(props: React.ComponentPropsWithoutRef<'a'>) {
    return (
        <Headless.DataInteractive>
            <a className={classNames('underline hover:text-sky-800', props.className)} {...props} />
        </Headless.DataInteractive>
    )
}
